// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__uzpRp","row":"Node_row__3GSbG","label":"Node_label__1FqLg","footer":"Node_footer__qgrrt"};